/**
 * Query keys for React Query
 * Centralized query key management for consistent cache invalidation
 */

export const queryKeys = {
  // Current user data (after login)
  user: ['user'] as const,
  // Business trips data
  trips: ['trips'] as const,
  tripApprovals: ['trip-approvals'] as const,
  trip: (id: string) => ['trip', id] as const,
  tripCities: (tripId: string) => ['trip-cities', tripId] as const,
  tripCity: (tripId: string, cityId: number) => ['trip', tripId, 'cities', cityId] as const,
  tripCosts: (tripId: string) => ['trip', tripId, 'costs'] as const,
  documents: ['documents'] as const,
  // Employee data
  employees: ['employees'] as const,
  substituteEmployees: (startDate: string, endDate: string) =>
    ['substitute-employees', startDate, endDate] as const,
  // Location data
  countries: ['countries'] as const,
  cities: (country: string) => ['cities', country] as const,
  currencies: ['currencies'] as const,
  fuelTypes: ['fuel-types'] as const,
} as const;
